import React from 'react'
import {Box, useMediaQuery, useTheme} from "@mui/material";
import Header from "./Header";
import {useTranslation} from "react-i18next";


const Title = () =>{
    const {t} = useTranslation();
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    return(
        <Box
            display={smScreen ? "flex" : "block"}
            flexDirection={smScreen ? "row" : "column" as any}
            justifyContent={smScreen ? "space-between" : "start"}
            alignItems={smScreen ? "center" : "start"}
        >
            <Header title={t('home_page.title' as any)}
                    subtitle={t('general.tum' as any)}/>
        </Box>
    )
}
export default Title
